module.exports = __webpack_public_path__ + "static/media/1.9_preview.a2fda7fb.png";